angular
  .module('ui-ng-calendar-time')
  .controller('WeekCalendarTimeController', function ($scope, DayOfTheWeekEnum, calendarTimeFn) {
    var TIME_HELPER = moment();

    $scope.visualization = {};
    $scope.visualization.hourDivisions =
      parseInt(($scope.specification.hourEnd - $scope.specification.hourBegin) / $scope.specification.hourStep, 10) + 1;
    $scope.visualization.hourPercentageHeight = 100 / $scope.visualization.hourDivisions;
    $scope.visualization.hourRange = _.times($scope.visualization.hourDivisions, function (i) {
      return {
        humanFormat: TIME_HELPER.hour($scope.specification.hourBegin + i)
          .minute(0)
          .format('h a'),
        val: $scope.specification.hourBegin + i
      };
    });

    $scope.visualization.onlineClasses = function () {
      return _.filter($scope.times, function (time) {
        return DayOfTheWeekEnum.isEqual(time.day, DayOfTheWeekEnum.ONLINE);
      });
    };

    $scope.visualization.offlineClasses = function () {
      return _.filter($scope.times, function (time) {
        return !DayOfTheWeekEnum.isEqual(time.day, DayOfTheWeekEnum.ONLINE);
      });
    };

    $scope.timeRequest = {
      isPainting: false,
      day: undefined,
      anchor: {},
      seekTo: {},
      draw: {
        height: undefined,
        top: undefined
      }
    };

    $scope.getOnlineClassColSpan = function getOnlineClassColSpan(includeWeekends) {
      return includeWeekends === 'false' ? 5 : 7;
    };

    $scope.calculateMarginOffset = function calculateMarginOffset(onlineClasses) {
      return onlineClasses.length * 18 + 'px';
    };

    $scope.isInTimeRange = function isInTimeRange(timeRequest, hourValue) {
      var firstHour, lastHour, currentHour, anchorHourValue, seekToHourValue;

      if (!$scope.timeRequest.isPainting) {
        return false;
      }

      anchorHourValue = timeRequest.anchor.value + $scope.specification.hourBegin;
      seekToHourValue = timeRequest.seekTo.value + $scope.specification.hourBegin;

      if (!!anchorHourValue && !!seekToHourValue) {
        firstHour = Math.floor(Math.min(seekToHourValue, anchorHourValue));
        lastHour = Math.ceil(Math.max(seekToHourValue, anchorHourValue));
        currentHour = hourValue;
        return currentHour >= firstHour && currentHour <= lastHour;
      } else {
        return false;
      }
    };

    $scope.timeToPercentage = function timeToPercentage(time) {
      return $scope.visualization.hourPercentageHeight * time;
    };

    $scope.calculateSpatialTime = function calculateSpatialTime(hour, minutes) {
      return hour - $scope.specification.hourBegin + $scope.convertMinutesToHours(minutes);
    };

    $scope.convertMinutesToHours = function convertMinutesToHours(minutes) {
      return minutes / 60;
    };

    $scope.timeUnitTop = function timeUnitTop(time) {
      var hour = time.from.hour() - $scope.specification.hourBegin;
      var minutes = $scope.convertMinutesToHours(time.from.minutes());

      return $scope.timeToPercentage(hour + minutes) + '%';
    };

    $scope.timeUnitHeight = function timeUnitHeight(time) {
      var to = $scope.calculateSpatialTime(time.to.hour(), time.to.minutes());
      var from = $scope.calculateSpatialTime(time.from.hour(), time.from.minutes());

      return $scope.timeToPercentage(to - from) + '%';
    };

    $scope.startPainting = function startPainting($event) {
      var hour, minutes;

      if (!!$scope.readOnly) {
        return;
      }

      $scope.timeRequest.isPainting = true;

      if (_.isUndefined($event.target.attributes['data-day'])) {
        return;
      }

      $scope.timeRequest.draw.height = undefined;
      $scope.timeRequest.draw.top = undefined;

      $scope.timeRequest.day = $event.target.attributes['data-day'].value;
      hour = $scope.timeRequest.anchor.hour = parseInt($event.target.attributes['data-hour'].value, 10);
      minutes = $scope.timeRequest.anchor.minutes = parseInt($event.target.attributes['data-minutes'].value, 10);
      $scope.timeRequest.anchor.value = $scope.calculateSpatialTime(
        $scope.timeRequest.anchor.hour,
        $scope.timeRequest.anchor.minutes
      );
      $scope.timeRequest.anchor.moment = moment(hour + ':' + minutes, 'HH:mm');

      $scope.timeRequest.seekTo.value = $scope.timeRequest.anchor.value;
      $scope.timeRequest.hasStartedOnTime = calendarTimeFn.doesDayHaveTime(
        $scope.times,
        $scope.timeRequest.day,
        $scope.timeRequest.anchor.moment
      );
    };

    $scope.painting = function painting($event) {
      var anchor, seekTo, hour, minutes;

      if (!!$scope.readOnly) {
        return;
      }

      if (!$scope.timeRequest.isPainting) {
        return;
      }

      if (_.isUndefined($event.target.attributes['data-day'])) {
        return;
      }

      hour = parseInt($event.target.attributes['data-hour'].value, 10);
      minutes = parseInt($event.target.attributes['data-minutes'].value, 10);

      seekTo = $scope.calculateSpatialTime(hour, minutes);
      anchor = $scope.timeRequest.anchor.value;

      $scope.timeRequest.seekTo.value = seekTo;

      $scope.timeRequest.draw.height = $scope.timeToPercentage(Math.abs(anchor - seekTo)) + '%';
      $scope.timeRequest.draw.top =
        anchor < seekTo ? $scope.timeToPercentage(anchor) + '%' : $scope.timeToPercentage(seekTo) + '%';
    };

    $scope.endPainting = function endPainting($event) {
      var shouldAdd, shouldJoin, hasStartedOnTime, hasEndedOnTime;
      var startedTimeBlock, endedTimeBlock;

      var anchor = $scope.timeRequest.anchor;
      var hour = parseInt($event.target.attributes['data-hour'].value, 10);
      var minutes = parseInt($event.target.attributes['data-minutes'].value, 10);

      var anchorMoment = anchor.moment;
      var seekToMoment = moment(hour + ':' + minutes, 'HH:mm');

      var anchorTime = $scope.calculateSpatialTime(anchor.hour, anchor.minutes);
      var seekToTime = $scope.calculateSpatialTime(hour, minutes);

      var killTime;
      var operationArea = {};

      if (!!$scope.readOnly) {
        return;
      }

      $scope.timeRequest.isPainting = false;

      if (anchorTime > seekToTime) {
        operationArea.from = seekToMoment;
        operationArea.to = anchorMoment;
      } else if (anchorTime < seekToTime) {
        operationArea.from = anchorMoment;
        operationArea.to = seekToMoment;
      } else {
        killTime = calendarTimeFn.findTimeForDay($scope.times, $scope.timeRequest.day, anchorMoment);
        if (!!killTime && (!$scope.onSelected || $scope.onSelected({ time: killTime }) !== false)) {
          _.remove($scope.times, killTime);
        }
      }

      if (_.isEmpty(operationArea)) {
        $scope.whenUpdated({ times: $scope.times });
        return;
      }

      hasStartedOnTime = $scope.timeRequest.hasStartedOnTime;
      startedTimeBlock = calendarTimeFn.findTimeForDay($scope.times, $scope.timeRequest.day, anchorMoment);
      endedTimeBlock = calendarTimeFn.findTimeForDay($scope.times, $scope.timeRequest.day, seekToMoment);

      hasEndedOnTime = !_.isUndefined(endedTimeBlock);
      shouldAdd = (!hasStartedOnTime && !hasEndedOnTime) || (hasStartedOnTime && !hasEndedOnTime);
      shouldJoin = hasStartedOnTime && hasEndedOnTime && startedTimeBlock !== endedTimeBlock;

      if (shouldJoin || shouldAdd) {
        $scope.$parent.times = calendarTimeFn.addTimeOfDay($scope.times, $scope.timeRequest.day, operationArea);
      } else {
        $scope.$parent.times = calendarTimeFn.removeTimeFromDay($scope.times, $scope.timeRequest.day, operationArea);
      }

      $scope.$parent.times = calendarTimeFn.collapseTimes($scope.times);
      $scope.whenUpdated({ times: $scope.times });
    };
  })
  .directive('weekCalendarTime', function calendarWeek() {
    'use strict';

    return {
      restrict: 'E',
      require: '^calendarTime',
      replace: false,
      scope: false,
      controller: 'WeekCalendarTimeController',
      templateUrl: 'ui-ng-calendar-time/src/components/week_calendar_time/week_calendar_time.html',
      link: function (scope, element, attrs) {
        var className = 'week-calendar-time';
        if (scope.includeWeekends === 'false') {
          className += ' week-calendar-time--weekdays-only';
        }
        if (scope.alignTimes === 'left' || scope.alignTimes === 'both') {
          className += ' week-calendar-time--times-left';
        }
        if (scope.alignTimes === 'right' || scope.alignTimes === 'both') {
          className += ' week-calendar-time--times-right';
        }
        element.addClass(className);
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar-time/src/components/week_calendar_time/week_calendar_time.js